import universalKioskEnCommon from './universal-kiosk-en-common.json';
import universalKioskFrCommon from './universal-kiosk-fr-common.json';
import webappEnCommon from './webapp-en-common.json';
import webappFrCommon from './webapp-fr-common.json';

export const languageOptions = [
  {
    code: 'en',
    label: 'English',
    nativeLabel: 'English',
    flagCode: 'us',
  },
  {
    code: 'fr',
    label: 'French',
    nativeLabel: 'Français',
    flagCode: 'fr',
  },
];

const fallbackTranslations = {
  'universal-kiosk': {
    en: {
      common: universalKioskEnCommon,
    },
    fr: {
      common: universalKioskFrCommon,
    },
  },
  webapp: {
    en: {
      common: webappEnCommon,
    },
    fr: {
      common: webappFrCommon,
    },
  },
};

export default fallbackTranslations;
